import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { Workstation } from '../types';

class WorkstationService extends BaseService<Workstation> {
  constructor() {
    super('workstations');
  }
  canDelete = true;

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const workstationService = new WorkstationService();
